import { HttpErrorResponse } from '@angular/common/http';
import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { EMPTY, Observable, Subject, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { catchError, tap } from 'rxjs/operators';

import { TipoMensagem } from '../_classes/enum/tipo_mensagem';
import { Mensagem } from '../_classes/mensagem';
import { Util } from '../_classes/util';
import { EnvService } from '../_servicos/env.service';
import { MensagemService } from '../_servicos/mensagem.service';
import { RamalEditarService } from '../_servicos/ramal-editar-service';
import { Servidor } from './../_classes/servidor';
import { ServidorSrh2 } from './../_classes/servidor-srh2';
import { FotoService } from './../_servicos/foto.service';
import { RestService } from './../_servicos/rest.service';
import { ServidorService } from './../_servicos/servidor.service';
import { ModalAlertaService } from './../shared/modal-alerta.service';

@Component({
  selector: 'app-card-perfil',
  templateUrl: './card-perfil.component.html',
  styleUrls: ['./card-perfil.component.scss'],
})
export class CardPerfilComponent implements OnInit, OnDestroy {
  servidor$: Observable<Servidor>; // Servidor = new Servidor();
  servidor: Servidor;
  servidorSrh2: ServidorSrh2;
  servidorSrh2$: Observable<ServidorSrh2>;
  erros$ = new Subject<boolean>();
  inscricao: Subscription;
  simularNome;
  //prod;

  carregando = false;
  foto = null;

  public innerWidth: any;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

  constructor(
    public rest: RestService,
    private alertService: ModalAlertaService,
    private servService: ServidorService,
    private _fS: FotoService,
    private sanitizer: DomSanitizer,
    private ramalEditarService: RamalEditarService,
    private env: EnvService,
    private mensagemService: MensagemService
  ) {
    this.ramalEditarService.emitir(false);
    //this.prod = this.env.production;
  }

  ngOnDestroy() {
    //console.log('ngOnDestroy');
    if (this.inscricao) {
      this.inscricao.unsubscribe();
    }
  }
  getCkolling() {
    return this.servidor?.usuario?.dsNomeUsu === 'CKOLLING';
  }

  deuErro(err) {
    this.carregando = false;
  }

  executarAoCarregar(s: Servidor) {
    //console.log('executarAoCarregar', s);
    this.servidor = new Servidor(s);

    const blob = new Blob(
      [Util.Base64ToBlob(this._fS.getFoto(s.idServidor?.toString()))],
      {
        type: 'image/bmp',
      }
    );
    let arquivoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      window.URL.createObjectURL(blob)
    );
    this.foto = blob ? (blob.size > 5 ? arquivoUrl : null) : null;

    if (this.servidor) {
      // console.log('precisei buscar');
      if (!this.servidorSrh2 || this.servidorSrh2.nom == '') {
        this.servidorSrh2$ = this.rest
          .getServidorSrh2(this.servidor.nrMatricula)
          .pipe(
            tap((a) => this.executarAoCarregarDatasource(a)),
            take(1),
            catchError((e) => {
              this.handleError(e);
              return EMPTY;
            })
          );
      }
    }
    this.carregando = false;
  }

  alterarEditarRamal() {
    this.ramalEditarService.emitir(!this.ramalEditarService.ramalEditar);
  }

  crisostomo() {
    this.carregando = true;
    const servidorABuscar = 'CKOLLING';
    //console.log('card-perfil: Buscando servidor: ' + servidorABuscar);
    //console.log('CKOLLING-card-crisostomo');
    this.rest.getServidor(servidorABuscar).subscribe(
      (data: Servidor) => {
        this.servidor = new Servidor(data);
        if (data) {
          this.servService.alterarServidor(this.servidor);
        }
        this.carregando = false;
      },
      (err) => {
        this.carregando = false;
        let erro: HttpErrorResponse;
        erro = err;
        if (!erro.ok) {
          console.log(err);
        }
      }
    );
  }

  private registrarErro(msg: string) {
    let m = new Mensagem();
    m.tipo = TipoMensagem.ERRO;
    m.mensagem = msg;
    this.mensagemService.registrarMensagem(m);
  }

  simular() {
    this.carregando = true;
    //console.log('CKOLLING-card-simular');
    //console.log('card-perfil: Buscando servidor: ' + servidorABuscar);
    this.rest
      .getServidor(this.simularNome ? this.simularNome : 'CKOLLING')
      .subscribe(
        (data: Servidor) => {
          //console.log('card-perfil: veio algum resultado');
          this.servidor = new Servidor(data);

          if (data) {
            // Object.assign(this.servidor, data);
            this.servidorSrh2$ = this.rest.getServidorSrh2(
              this.servidor.nrMatricula
            );
            this.servidorSrh2$.subscribe(
              (a) => {
                if (this.servidor) {
                  this.servidor.servidorSrh2 = new ServidorSrh2(a);
                  this.servService.alterarServidor(this.servidor);
                }
              },
              (e) => {
                this.registrarErro('Erro ao buscar dados do servidor');
                return EMPTY;
              }
            );
          }
          this.carregando = false;
        },
        (err) => {
          this.carregando = false;
          let erro: HttpErrorResponse;
          erro = err;
          if (!erro.ok) {
            //console.log(err);
          }
        }
      );
  }

  executarAoCarregarDatasource(x: ServidorSrh2) {
    this.servidorSrh2 = new ServidorSrh2(x);
    this.carregando = false;
  }

  mobile(): boolean {
    return this.innerWidth < 950;
  }

  ngOnInit() {
    this.carregando = true;
    this.innerWidth = window.innerWidth;
    this.servidor = this.env.servidor;

    if (this.env.servidor) {
      this.executarAoCarregar(this.env.servidor);
    } else {
      this.inscricao = this.servService.getServidor().subscribe((usr) => {
        this.executarAoCarregar(usr);
        this.inscricao.unsubscribe();
      });
      /*
      this.servidor$ = this.servService.getServidor().pipe(
        tap((d) => {
          this.executarAoCarregar(d);
        }),
        catchError((e) => {
          console.error(e);
          this.erros$.next(true);
          return empty();
        })
      );*/
    }
  }

  alterarLoading() {
    this.carregando = !this.carregando;
  }

  getFuncao(s: Servidor): string {
    let funcao = '';

    // //console.log('Verificar FC');
    // //console.log(this.servidor);
    if (s != null) {
      if (s.servidorTodos.dsFuncaoComissionada != null) {
        funcao = s.servidorTodos.dsFuncaoComissionada;
      }

      if (s.servidorTodos.dsFuncaoComissionada != null) {
        if (funcao != '') {
          funcao = funcao + ' - ' + s.servidorTodos.dsFuncaoConfianca;
        } else {
          funcao = s.servidorTodos.dsFuncaoConfianca;
        }
      }
    }
    return funcao;
  }

  handleError(e: any) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }
}
